<ng-container>
    <div class="w-100 float-left">
        <div *ngIf="previewAnalyticalModel && previewAnalyticalModel == 'error' && !loader"
             class="w-100 float-left mt-3">
            <b> No Data for preview</b>
        </div>
        <div *ngIf="previewAnalyticalModel && previewAnalyticalModel != 'error'" class="main-table table-custom">
            <div class="w-100 float-left mt-3">
                <div class="table-responsive text-nowrap">
                    <table class="table table-bordered table-hover table-striped">
                        <thead class="thead-dark">
                        <tr>
                            <th *ngFor="let header of previewAnalyticalModel.headers">
                                <h6 class="mb-lg-0 medium"> {{header}} </h6>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let row of previewAnalyticalModel.rows">
                            <td *ngFor="let header of previewAnalyticalModel.headers, let i = index">
                                <h6 class="mb-lg-0 text-truncate"> {{row[i]}} </h6>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!-- PAGINATION -->
                <div *ngIf="(previewAnalyticalModel.headers.length && previewAnalyticalModel.rows.length)"
                     class="w-100 float-left my-4 light-bg p-3 align-v-center">
                    <h6 class="float-left mb-0 mr-4"> {{startingPage + 1}} - {{endingPage}} items of {{total}} </h6>
                    <div class="float-left ml-2 align-v-center">
                        <label class="m-0 float-left">Show items per page</label>
                        <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                                (change)="OnPageSizeChanged($event)">
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                        </select>
                    </div>
                    <div style="flex-grow: 1;"></div>
                    <ngb-pagination [collectionSize]="total" [rotate]="true" [pageSize]="pageSize" [ellipses]="false"
                                    [maxSize]="5"
                                    [boundaryLinks]="true" [(page)]="currentPage" (pageChange)="onPageChange($event)"
                                    class="float-right"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/dataPreview.html